import { apartmentReserve, fetchAboutApartmentById,
  page, sendSearchDataToApi } from '@/services/api';
import { AxiosResponse } from 'axios';
import { IAboutApartmentData, IAboutApartmentTranslation } from '@/types';
import { Action, Module, Mutation,
  VuexModule } from 'vuex-module-decorators';
import { ICatalogPage, ITranslation, ICatalogList } from '@/types';

const GET_CATALOG_APARTMENTS = 'GET_CATALOG_APARTMENTS';
const GET_NEXT_PAGE_APARTMENTS = 'GET_NEXT_PAGE_APARTMENTS';
const GET_SEARCH_CATALOG_LIST_APARTMENTS = 'GET_SEARCH_CATALOG_LIST_APARTMENTS';
const RESERVE_APARTMENT = 'RESERVE_APARTMENT';
const SET_ABOUT_APARTMENT_DATA = 'SET_ABOUT_APARTMENT_DATA';
const SET_CATALOG_TRANSLATION = 'SET_CATALOG_TRANSLATION';

const rawError: boolean = true;

@Module({namespaced: true})
export default class CatalogPage extends VuexModule implements ICatalogPage {

  public aboutApartment = {
    reservation: false,
    price_total: 0,
    currency: '',
    currency_per_month: '',
    id: '',
    price: '',
    start: '',
    end: '',
    floor: '',
    operator: 0,
    photos: [],
    design: '',
    rooms: '',
    house_rules: '',
    option_categories: [],
    title: '',
    description: '',
    area: '',
    building: '',
    views: [],
    rule_smoking_allowed: null,
    rule_pets_allowed: null,
    rule_parties_allowed: null,
    per_object_permissions: [],
    price_guarantee_payment: 0,
  };

  public translation: ITranslation = {
    aboutApartment: {
      apartment_characteristic: {
        building: '',
        floor: '',
        rooms: '',
        area: '',
        apartment_street_view: '',
      },
      apartment_description: {
        title: '',
      },
      back_button_name: '',
      slider: {
        view_all_button_name: '',
      },
      options: {
        title: '',
      },
      rent_block: {
        rent_period: '',
        start_date: '',
        period_month: '',
        period_year: '',
        rent_per_first_month: '',
        guarantee_payment: '',
        total: '',
        button_name: '',
        hint_promo: '',
        guarantee_promo: '',
      },
      rules: {
        title: '',
        rules_house: '',
        rules_apartment: '',
        rule_parties_allowed: '',
        rule_pets_allowed: '',
        rule_smoking_allowed: '',
      },
      similar_rent_ad_requests: {
        title: '',
        rooms: '',
        floor: '',
        button_name: '',
      },
    },
    checkout: {},
    title: '',
    additionalFilters: {},
    filtersApartment: {},
    catalogListTexts: {
      countText: '',
      clearFilters: '',
      sortCount: {
        title: '',
        items: [20, 50, 100],
      },
      sortTypes: {
        title: '',
        items: [
          {
            name: '',
            value: 'price',
          },
        ],
      },
      emptyCatalog: {
        firstLineText: '',
        secondLineText: '',
      },
      mobTitleText: '',
    },
    pagination: {},
    catalogItem: {
      room_plural: 'комнат | комната | комнаты | ${count} комнат',
    },
  };

  public catalogListData: ICatalogList = {
    count: 0,
    next: '',
    previous: '',
    results: [],
  };

  @Mutation
  public [SET_ABOUT_APARTMENT_DATA](payload: AxiosResponse): void {
    if (payload && payload.status === 200 && payload.data) {
      this.aboutApartment = payload.data;
    }
  }

  @Mutation
  public [SET_CATALOG_TRANSLATION](payload: Record<'translations', ITranslation>): void {
    this.translation = {...this.translation, ...payload.translations};
  }

  @Mutation
  public [GET_CATALOG_APARTMENTS](payload: ITranslation): void {
    this.translation.filtersApartment = payload.filtersApartment;
  }

  @Mutation
  public [GET_NEXT_PAGE_APARTMENTS](payload: Record<'data', ICatalogList>): void {
    this.catalogListData.results = this.catalogListData.results.concat(payload.data.results);
  }

  @Mutation
  public [GET_SEARCH_CATALOG_LIST_APARTMENTS](payload: Record<'data', ICatalogList>): void {
    this.catalogListData = {...this.catalogListData, ...payload.data};
  }

  @Mutation
  public [RESERVE_APARTMENT](): void {
    this.aboutApartment.reservation = true;
  }

  public get aboutApartmentTranslation(): {} {
    return this.translation.aboutApartment;
  }

  public get aboutApartmentData(): {} {
    return this.aboutApartment;
  }

  public get titlePage(): {} {
    return this.translation.title;
  }

  public get filtersApartment(): {} {
    return this.translation.filtersApartment;
  }

  public get catalogListTexts(): {} {
    return this.translation.catalogListTexts;
  }

  public get pagination(): {} {
    return this.translation.pagination;
  }

  public get catalogItem(): {} {
    return this.translation.catalogItem;
  }

  public get additionalFilters(): {} {
    return this.translation.additionalFilters;
  }

  public get catalogList(): {} {
    return this.catalogListData;
  }

  public get checkoutTexts(): {} {
    return this.translation.checkout;
  }

  @Action({commit: SET_ABOUT_APARTMENT_DATA, rawError})
  public fetchAboutApartment(id) {
    return fetchAboutApartmentById(id);
  }

  @Action({commit: SET_CATALOG_TRANSLATION, rawError})
  public async fetchTranslation() {
    const data = await page('catalog');
    return data ? data : this.translation;
  }

  @Action({commit: GET_SEARCH_CATALOG_LIST_APARTMENTS, rawError})
  public sendSearchData(data) {
    return sendSearchDataToApi('catalog', data);
  }

  @Action({commit: GET_NEXT_PAGE_APARTMENTS, rawError: true})
  public getNextPageApartments(data) {
    return sendSearchDataToApi('catalog', data);
  }

  @Action
  public reserveActualApartment(id) {
      return apartmentReserve(id)
          .then((response) => {
            if (response.status === 200) {
              this.context.dispatch('setApartmentReserved');
            }
            return response;
          })
          .catch((error) => console.error(error));
  }

  @Action({commit: RESERVE_APARTMENT, rawError})
  public setApartmentReserved() {}
}
